/**
 * Адрес API. Одно правило на всё приложение.
 *
 * Приложение живёт на нескольких доменах (webtransfer.app,
 * kredafi.webtransfer.app, developer-*.webtransfer.app), а API — один и тот же
 * на webtransfer.app. Исключение — dev-хост: там API должно идти к своему
 * бэкенду, иначе все дев-патчи в /development/api/* минуются.
 *
 * Вынесено из useAxiosSetup, потому что базу знать нужно и до того, как хук
 * успел её проставить: диагностика кошельков стучится в API напрямую, минуя
 * axios.defaults, и относительный путь с kredafi.webtransfer.app привёл бы её
 * в статику, а не в API.
 */
export function apiBaseUrl(): string {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined') {
    if (window.location.hostname.includes('kredafi.com') || window.location.hostname.startsWith('developer-')) {
      return window.location.origin;
    }
  }
  return 'https://webtransfer.app';
}
